import { createAsyncThunk } from "@reduxjs/toolkit";
import HotelApi from "api/HotelApi";

export const fetchHotel = createAsyncThunk(
  "fetchHotel",
  ({ companyId }: { companyId: number }) => HotelApi.fetchHotel(companyId)
);
